import { HeaderContainer } from '@squareup/dex-feature-shared-main-header-container';
import { Box } from '@squareup/dex-ui-shared-base';
import React, { FC, useMemo } from 'react';

import styles from './legacy-sdk-ref-page.module.css';

type Platform =
  | 'reader_ios'
  | 'reader_android'
  | 'in_app_payment_ios'
  | 'in_app_payment_android'
  | 'point_of_sale_android'
  | 'point_of_sale_ios';

interface LegacySdkRefPageProps {
  platform: Platform;
}

const staticPath: Record<Platform, string> = {
  reader_ios: '/docs/sdk/reader/ios/index.html',
  reader_android: '/docs/sdk/reader/android/index.html',
  in_app_payment_ios: '/docs/sdk/in-app-payment/ios/index.html',
  in_app_payment_android: '/docs/sdk/in-app-payment/android/index.html',
  point_of_sale_android: '/docs/sdk/point-of-sale/android/index.html',
  point_of_sale_ios: '/docs/sdk/point-of-sale/ios/index.html',
};

const platformTitles: Record<Platform, string> = {
  reader_ios: 'Reader SDK for iOS',
  reader_android: 'Reader SDK for Android',
  in_app_payment_ios: 'In-App Payments SDK for iOS',
  in_app_payment_android: 'In-App Payments SDK for Android',
  point_of_sale_android: 'Point of Sale SDK for Android',
  point_of_sale_ios: 'Point of Sale SDK for iOS',
};

export const LegacySdkRefPage: FC<LegacySdkRefPageProps> = ({ platform }) => {
  const header = useMemo(() => {
    return (
      <HeaderContainer
        slim={true}
        searchDomain="docs"
        disableHamburgerMenu
        hideSearch
      />
    );
  }, []);

  return (
    <Box className={styles['layout-wrap']}>
      {header}
      <iframe
        data-testid="legacy-sdk-iframe"
        src={staticPath[platform]}
        className={styles['iframe']}
        title={`${platformTitles[platform]} Documentation`}
        aria-label={`Documentation for ${platformTitles[platform]}`}
      />
    </Box>
  );
};
